import axios from '@/lib/axios';
import { PaymentTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1140. 支払タスク請求書チェック編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/update_invoice_checked
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  invoice_checked: boolean;
};

const updateInvoiceCheck = (props: Props): Promise<PaymentTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/update_invoice_checked`,
    props
  );
};

export const useUpdateInvoiceCheck = () => {
  return useMutation({
    mutationFn: updateInvoiceCheck,
  });
};
